import { FC, useMemo } from 'react';

import { VideoSlice } from '@/types';

import DefaultVariation from './DefaultVariation';
import HeroVideoVariation from './HeroVideoVariation';
import { dimensionsToAspectRatio } from 'utils/utils';

const Video: FC<VideoSlice> = slice => {
  const { preview_image } = slice?.primary || {};

  const widthPoster = preview_image?.dimensions?.width;
  const heightPoster = preview_image?.dimensions?.height;

  const isDefault = slice.variation === 'default';

  const initialAspectRatio = useMemo(() => {
    // We are going to set the aspect ratio to '16:9'
    // which is equivalent to the default size of our Hero images 1920x640,
    // this is an alternative because we do not know the width and height of the video.
    if (!widthPoster || !heightPoster) {
      return isDefault ? '3/1' : '16/9';
    }

    //
    return dimensionsToAspectRatio(widthPoster, heightPoster);
  }, [widthPoster, heightPoster, isDefault]);

  if (!slice?.primary?.active) {
    return null;
  }

  if (slice.variation === 'heroVideo') {
    return (
      <HeroVideoVariation aspectRatio={initialAspectRatio} slice={slice} />
    );
  }

  return <DefaultVariation aspectRatio={initialAspectRatio} slice={slice} />;
};

export default Video;
